import type { AclInfo, UseAclInfo } from '@openx/utils/permission/context/PermissionHookTypes.ts';
import { unpackAcl } from '@openx/utils/permission/unpackAcl.ts';
import { useMemo } from 'react';
import { useAuth } from '../../../components/AuthContext/context.ts';

export const useAclInfo: UseAclInfo = () => {
  const { loading, session } = useAuth();

  const info = useMemo<AclInfo | undefined>(() => {
    if (!session) {
      return undefined;
    }

    return {
      account: unpackAcl(session.exchange_session.account.compiled_acl),
      list: unpackAcl(session.exchange_session.compiled_acl),
      mapping: session.exchange_session.acl_mapping,
      user: unpackAcl(session.exchange_session.user.compiled_acl),
    };
  }, [session]);

  return {
    info,
    isLoading: loading,
  };
};
